import { Horizontal, Vertical } from "@/components/standard/BFLayout"
import TimelineCompleteIcon from "@/assets/icons/teal-check.svg"
import TimelineInProgressIcon from "@/assets/icons/timeline-inprogress.svg"
import TimelineTodoIcon from "@/assets/icons/timeline-todo.svg"
import TimelineWaitingIcon from "@/assets/icons/timeline-waiting-grey.svg"
import TimelineWaitingUrgentIcon from "@/assets/icons/timeline-waiting.svg"

import { type FC, type ReactNode } from "react"
import { type SvgProps } from "react-native-svg"
import { H5, Small } from "@/components/standard/BFText"
import { View } from "react-native"
import { BFColors } from "@/constants/Colors"

const ICONS: Record<TimelineStatus, FC<SvgProps>> = {
  complete: TimelineCompleteIcon,
  inprogress: TimelineInProgressIcon,
  todo: TimelineTodoIcon,
  waiting: TimelineWaitingIcon,
  waiting_urgent: TimelineWaitingUrgentIcon,
}

export interface DashboardTimelineProps {
  items: TimelineEntry[]
  className?: string
}

export type TimelineStatus =
  | "complete"
  | "inprogress"
  | "todo"
  | "waiting"
  | "waiting_urgent"

export interface TimelineEntry {
  title: string
  description?: string | ReactNode
  status: TimelineStatus
}

const TimelineItem = ({
  title,
  description,
  status,
  last,
}: TimelineEntry & { last: boolean }) => {
  const Icon = ICONS[status]

  return (
    <Horizontal
      className={`relative ${status === "todo" && "opacity-50"} min-h-10`}
    >
      <View
        className={"w-5"}
        style={{
          borderColor: last ? "transparent" : BFColors.lightGrey,
          borderLeftWidth: 1,
          marginTop: 6,
        }}
      />
      <Vertical className={`${status === "todo" && "opacity-50"} pb-6 flex-1`}>
        <H5>{title}</H5>
        {description && <Small>{description}</Small>}
      </Vertical>
      <Icon
        style={{
          position: "absolute",
          left: -6,
          top: 4,
        }}
      />
    </Horizontal>
  )
}

export const DashboardTimeline = ({
  items,
  className,
}: DashboardTimelineProps) => {
  if (!items) {
    return null
  }

  return items.map((item, index) => (
    <TimelineItem key={index} {...item} last={index === items.length - 1} />
  ))
}
